import { render, staticRenderFns } from "./TokensEditor.vue?vue&type=template&id=08551ee3"
import script from "./TokensEditor.vue?vue&type=script&lang=js"
export * from "./TokensEditor.vue?vue&type=script&lang=js"
import style0 from "./TokensEditor.vue?vue&type=style&index=0&id=08551ee3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports